module.exports = __webpack_public_path__ + "img/preview.d18e47ab.png";